import {
  BufferGeometry,
  Color,
  Float32BufferAttribute,
  LineBasicMaterial,
  LineLoop,
  Quaternion,
  Vector3,
} from "three";

import { EARTH_RADIUS } from "./constants";

// ============================================================
//  Terminator line — the great circle where the sun sits on the
//  horizon. Built once as a circle in the XY plane and turned each
//  frame so its axis points at the sun.
// ============================================================

const SEGMENTS = 360;
const RADIUS = EARTH_RADIUS * 1.003;
const Z = new Vector3(0, 0, 1);

/** [dark, light] */
const COLORS: [number, number] = [0xff9d4a, 0xe07a52];

export interface TerminatorLine {
  mesh: LineLoop<BufferGeometry, LineBasicMaterial>;
  setSunDirection(v: Vector3): void;
  setTheme(t: number): void;
}

export function createTerminatorLine(): TerminatorLine {
  const positions: number[] = [];
  for (let i = 0; i < SEGMENTS; i++) {
    const a = (i / SEGMENTS) * Math.PI * 2;
    positions.push(Math.cos(a) * RADIUS, Math.sin(a) * RADIUS, 0);
  }
  const geo = new BufferGeometry();
  geo.setAttribute("position", new Float32BufferAttribute(positions, 3));

  const material = new LineBasicMaterial({
    color: COLORS[0],
    transparent: true,
    opacity: 0.9,
    depthWrite: false,
  });
  const mesh = new LineLoop(geo, material);
  mesh.frustumCulled = false;
  mesh.renderOrder = 3;
  mesh.visible = false;

  const q = new Quaternion();
  const dir = new Vector3();
  return {
    mesh,
    setSunDirection(v) {
      mesh.quaternion.copy(q.setFromUnitVectors(Z, dir.copy(v).normalize()));
    },
    setTheme(t) {
      material.color = new Color(COLORS[t > 0.5 ? 1 : 0]);
    },
  };
}
